import { useContext } from 'react'
import PropTypes from 'prop-types'

import {
  Button,
  Columns,
  LoadingModule,
  SaveFormModule,
} from '@domain-group/suit-theme'

import { digObject, generateRedirectUrl } from '@domain-group/javascript-utils'

import PageContext from '@contexts/pageContext'

import { generateUrls } from '@hooks/useProvider'
import usePublication, { usePublicationForm, useRelations } from '@hooks/usePublication'

import LinkToEntityModule from '@components/LinkToEntityModule'

import EntityAssets from '@components/EntityAssets'
import PageLayout from '../../../../components/PageLayout'

import KeyContacts from '../KeyContacts'
import Logo from '../Logo'
import PublicationDetails from '../PublicationDetails'
import PublicationSettings from '../PublicationSettings'
import PublicationTools from '../../../../components/PublicationTools'

const PageContent = (props) => {
  const { publicationId } = props

  const publicationPayload = usePublication({ id: publicationId })
  const {
    callbacks: {
      updatePublication: updateFn,
    },
    loading,
    publication,
    updating,
  } = publicationPayload

  const publicationForm = usePublicationForm(publication)
  const { entityState, saveEnabled } = publicationForm

  const pageContext = useContext(PageContext)
  const {
    callbacks,
    callbacks: { updatePublication },
  } = pageContext

  const { provider } = useRelations(publication)
  const {
    logo: providerLogo,
    short_name: providerShortName,
    title: providerTitle,
  } = provider

  const { editProviderUrl } = generateUrls(provider)

  const providerImageUrl = digObject(providerLogo, 'thumb', '')

  const updatePublicationPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Publication Updated',
  }

  return (
    <PageLayout entityPayload={publicationPayload}>
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {!loading && (
          <>
            <PublicationDetails publicationForm={publicationForm} />

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                disabled={!saveEnabled}
                loading={updating}
                onClick={() => updatePublication(updatePublicationPayload)}
                size="medium"
              >
                Save Details
              </Button>
            </SaveFormModule>
          </>
        )}
      </Columns.Main>

      <Columns.Sidebar>
        <LinkToEntityModule
          entityTitle={providerTitle}
          goToHref={`${editProviderUrl}?redirect=${generateRedirectUrl()}`}
          imageUrl={providerImageUrl}
          loading={loading}
          moduleTitle="Provider"
          secondaryText={providerShortName}
        />

        <PublicationTools publicationPayload={publicationPayload} />

        <PublicationSettings publicationForm={publicationForm} publicationPayload={publicationPayload} />

        <Logo publicationPayload={publicationPayload} />

        <EntityAssets
          callbacks={callbacks}
          filters={{
            attachableId: publication?.id,
            attachableType: 'Publication',
            attachmentType: 'publication_asset',
          }}
        />

        <KeyContacts publicationPayload={publicationPayload} />
      </Columns.Sidebar>
    </PageLayout>
  )
}

PageContent.propTypes = {
  publicationId: PropTypes.number.isRequired,
}

export default PageContent
